import React, { Component } from "react";
import { connect } from "react-redux";
import axios from "axios";
import Sidebar from "../components/Sidebar";
import Topbar from "../components/Topbar";
import Loading from "../components/Loading";
import { MDBDataTable } from "mdbreact";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { CSVLink } from "react-csv";

const mySwal = withReactContent(Swal);

class UserDetails extends Component {
	constructor(props) {
		super(props);
		this.state = {
			toggled: false,
			data: null,
			loading: true,
			error: null
		};
	}
	_isMounted = false;

	componentDidMount() {
		this._isMounted = true;
		if (this._isMounted) {
			if (!this.props.admin.admin && !this.props.admin.isAuthenticated) {
				this.props.history.push("/admin/dashboard");
			} else {
				const { operatorId } = this.props.admin.admin;

				axios
					.post("/api/admin/setting/getUsers", { operatorId }, { headers: { "Content-Type": "application/json", "auth-token": this.props.admin.token } })
					.then(res => {
						this.setState({
							...this.state,
							loading: false,
							data: res.data.data
						});
					})
					.catch(err => {
						this.setState({ ...this.state, loading: false });
						mySwal.fire("Error", err.response.data.error, "error");
					});
			}
		}
	}

	componentWillUnmount() {
		this._isMounted = false;
	}

	handleToggle = () => this.setState({ ...this.state, toggled: !this.state.toggled });

	// handleAction = (e, user) => {
	//     // console.log(e.target);
	//     // console.log({user});
	//     // edit stamp
	//     mySwal.fire({
	//         title: "Edit User Stamp",
	//         html: `
	//             <div class="mt-5">
	//                 <div>
	//                     <p>Name: <strong>${user.name}</strong></p>
	//                     <p>Number: <strong>${user.number}</strong></p>
	//                     <p>Member ID: <strong>${user.memberId}</strong></p>
	//                 </div>

	//                 <div class="form-group text-left">
	//                     <label for="washerStamp">Washer Stamp</label>
	//                     <input type="number" id="washerStamp" name="washerStamp" value="${user.washerStamp}" class="form-control browser-default" min="0" max="10" />
	//                 </div>

	//                 <div class="form-group text-left">
	//                     <label for="dryerStamp">Dryer Stamp</label>
	//                     <input type="number" id="dryerStamp" name="dryerStamp" value="${user.dryerStamp}" class="form-control browser-default" min="0" max="10" />
	//                 </div>

	//                 ${
	//                     this.props.admin.admin.token
	//                     ? `
	//                     <div class="form-group text-left">
	//                         <label for="token">Tokens</label>
	//                         <input type="number" id="token" name="token" value="${user.token || 0}" class="form-control browser-default" min="0" />
	//                     </div>`
	//                     : `<div id="token"></div>`
	//                 }
	//             </div>
	//         `,
	//         showLoaderOnConfirm: true,
	//         preConfirm: async () => {
	//             const newWasherStamp = document.querySelector("#washerStamp").value;
	//             const newDryerStamp = document.querySelector("#dryerStamp").value;
	//             const newToken = document.querySelector("#token").value || user.token;

	//             const currentWasherStamp = user.washerStamp;
	//             const currentDryerStamp = user.dryerStamp;
	//             const currentTotalStamps = user.totalStamps;
	//             const currentToken = user.token;

	//             const washerStampDiff = newWasherStamp - currentWasherStamp;
	//             const dryerStampDiff = newDryerStamp - currentDryerStamp;
	//             const tokenDiff = newToken - currentToken

	//             const newTotalStamps = currentTotalStamps + washerStampDiff + dryerStampDiff;

	//             const id = user._id;

	//             let sendThis = {
	//                 newWasherStamp,
	//                 newDryerStamp,
	//                 newToken,
	//                 currentWasherStamp,
	//                 currentDryerStamp,
	//                 currentTotalStamps,
	//                 currentToken,
	//                 washerStampDiff,
	//                 dryerStampDiff,
	//                 tokenDiff,
	//                 newTotalStamps,
	//                 id
	//             };

	//             try {
	//                 const res = await axios.post('/api/admin/setting/edit/userStamp' , sendThis , {headers : {"Content-Type" : "application/json", "auth-token" : this.props.admin.token}})
	//                 console.log(res.data);
	//                 const filteredList = this.state.data.filter(user => user._id !== res.data.data._id);
	//                 const newList = [...filteredList, res.data.data];
	//                 this.setState({
	//                     ...this.state,
	//                     data: newList
	//                 });
	//                 return true;
	//             } catch (err) {
	//                 return mySwal.showValidationMessage(err.response.data.error);
	//             }
	//         },
	//         allowOutsideClick: () => !mySwal.isLoading(),
	//         confirmButtonText : "SUBMIT",
	//         showCancelButton : true,
	//         cancelButtonText : "CANCEL"
	//     })
	//     .then(result => {
	//         if (result.isConfirmed && result.value) mySwal.fire("Success", "Updated user details", "success");
	//     });
	// };

	render() {
		let data = {
			columns: [
				{
					label: "Name",
					field: "name",
					sort: "asc"
				},
				{
					label: "Phone Number",
					field: "number",
					sort: "asc"
				},
				{
					label: "Birthday",
					field: "birthday",
					sort: "asc"
				},
				{
					label: "Age",
					field: "age",
					sort: "asc"
				},
				{
					label: "Email Address",
					field: "email",
					sort: "asc"
				},
				{
					label: "Member ID",
					field: "memberId",
					sort: "asc"
				},
				{
					label: "Washer Stamp",
					field: "washerStamp",
					sort: "asc"
				},
				{
					label: "Dryer Stamp",
					field: "dryerStamp",
					sort: "asc"
				},
				{
					label: "Total Stamps",
					field: "totalStamps",
					sort: "asc"
				},
				{
					label: "Vouchers Acquired",
					field: "totalVouchers",
					sort: "asc"
				},
				{
					label: "Total Washer Payment (RM)",
					field: "washerPayment",
					sort: "asc"
				},
				{
					label: "Total Dryer Payment (RM)",
					field: "dryerPayment",
					sort: "asc"
				},
				{
					label: "Total Payment (RM)",
					field: "totalPayment",
					sort: "asc"
				}
			],
			rows: []
		};

		let csv = [];

		if (this.state.data) {
			for (let i = 0; i < this.state.data.length; i++) {
				let data = {
					name: this.state.data[i].name,
					number: `=""${this.state.data[i].number}""`,
					birthday: new Date(this.state.data[i].birthday).toLocaleDateString('en-GB'),
					age: this.state.data[i].age,
					email: this.state.data[i].email,
					memberId: this.state.data[i].memberId,
					washerStamp: this.state.data[i].washerStamp,
					dryerStamp: this.state.data[i].dryerStamp,
					totalStamps: this.state.data[i].totalStamps,
					totalVouchers: this.state.data[i].totalVouchers,
					washerPayment: this.state.data[i].washerPayment,
					dryerPayment: this.state.data[i].dryerPayment,
					totalPayment: this.state.data[i].totalPayment,
					token: this.state.data[i].token,
					tokenPayment: this.state.data[i].tokenPayment,
					tokenPurchased: this.state.data[i].tokenPurchased,
					washerToken: this.state.data[i].washerToken,
					dryerToken: this.state.data[i].dryerToken,
					tokenUsed: this.state.data[i].tokenUsed
				}
				csv.push(data);
			}
		}

		const csvData = {
			headers: [
				{ label: "Name", key: "name" },
				{ label: "Phone Number", key: "number" },
				{ label: "Birthday", key: "birthday" },
				{ label: "Age", key: "age" },
				{ label: "Email Address", key: "email" },
				{ label: "Member ID", key: "memberId" },
				{ label: "Washer Stamp", key: "washerStamp" },
				{ label: "Dryer Stamp", key: "dryerStamp" },
				{ label: "Total Stamps", key: "totalStamps" },
				{ label: "Vouchers Acquired", key: "totalVouchers" },
				{ label: "Total Washer Payment (RM)", key: "washerPayment" },
				{ label: "Total Dryer Payment (RM)", key: "dryerPayment" },
				{ label: "Total Payment (RM)", key: "totalPayment" },
			],
			data: csv
		};

		if (this.props.admin?.admin?.token) {
			data.columns = [
				...data.columns,
				{
					label: "e-Tokens",
					field: "token",
					sort: "asc"
				},
				{
					label: "Bought e-Token using (RM)",
					field: "tokenPayment",
					sort: "asc"
				},
				{
					label: "Total e-Token Purchased (Tokens)",
					field: "tokenPurchased",
					sort: "asc"
				},
				{
					label: "Washer Payment (Tokens)",
					field: "washerToken",
					sort: "asc"
				},
				{
					label: "Dryer Payment (Tokens)",
					field: "dryerToken",
					sort: "asc"
				},
				{
					label: "Total Payment (Tokens)",
					field: "tokenUsed",
					sort: "asc"
				}
			];

			csvData.headers = [
				{ label: "Name", key: "name" },
				{ label: "Phone Number", key: "number" },
				{ label: "Birthday", key: "birthday" },
				{ label: "Age", key: "age" },
				{ label: "Email Address", key: "email" },
				{ label: "Member ID", key: "memberId" },
				{ label: "Washer Stamp", key: "washerStamp" },
				{ label: "Dryer Stamp", key: "dryerStamp" },
				{ label: "Total Stamps", key: "totalStamps" },
				{ label: "Vouchers Acquired", key: "totalVouchers" },
				{ label: "Total Washer Payment (RM)", key: "washerPayment" },
				{ label: "Total Dryer Payment (RM)", key: "dryerPayment" },
				{ label: "Total Payment (RM)", key: "totalPayment" },
				{ label: "e-Tokens", key: "token" },
				{ label: "Bought e-Token using (RM)", key: "tokenPayment" },
				{ label: "Total e-Token Purchased (Tokens)", key: "tokenPurchased" },
				{ label: "Washer Payment (Tokens)", key: "washerToken" },
				{ label: "Dryer Payment (Tokens)", key: "dryerToken" },
				{ label: "Total Payment (Tokens)", key: "tokenUsed" },
			]
		}

		if (this.state.data) {
			for (let i = 0; i < this.state.data.length; i++) {
				const user = this.state.data[i];
				const dataObject = {
					name: user.name,
					number: user.number,
					birthday: user.birthday,
					age: user.age,
					email: user.email,
					memberId: user.memberId,
					washerStamp: user.washerStamp,
					dryerStamp: user.dryerStamp,
					totalStamps: user.totalStamps,
					totalVouchers: user.totalVouchers,
					washerPayment: user.washerPayment,
					dryerPayment: user.dryerPayment,
					totalPayment: user.totalPayment,
					token: user.token,
					tokenPayment: user.tokenPayment,
					tokenPurchased: user.tokenPurchased,
					washerToken: user.washerToken,
					dryerToken: user.dryerToken,
					tokenUsed: user.tokenUsed
				};
				data.rows.push(dataObject);
			}
		}

		return (
			<div className="admin-page-container">
				<Sidebar toggled={this.state.toggled} setToggled={this.handleToggle} />
				<div className="admin-page">
					<Topbar handleToggle={this.handleToggle} />
					<div className="admin-content">
						{this.state.loading ? (
							<Loading />
						) : (
							<div className="card">
								<div className="card-header">
									<h5 className="card-title">User Details</h5>
								</div>

								<div className="card-body">
									<div className="text-center mt-5">
										<MDBDataTable data={data} noBottomColumns striped hover responsive bordered />
										<div className="d-grid gap-2 d-md-flex justify-content-md-end">
											<CSVLink className="btn btn-primary" data={csvData.data} headers={csvData.headers} filename="userDetails.csv" target="_blank">
												Download Report
											</CSVLink>
										</div>
									</div>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>
		);
	}
}

const mapStateToProps = state => {
	return {
		admin: state.admin
	};
};

export default connect(mapStateToProps, null)(UserDetails);
